import React, { HTMLAttributes } from "react";
import clsx from "clsx";

import useStyles from "./styles";

interface IProps extends HTMLAttributes<HTMLDivElement> {
  bold?: boolean;
  centered?: boolean;
  fadedOut?: boolean;
  lastOneColumnCell?: boolean;
  lastTwoColumnsCell?: boolean;
}

const TableCellWrapper = (props: IProps) => {
  const {
    children,
    className,
    bold = false,
    centered = false,
    fadedOut = false,
    lastOneColumnCell = false,
    lastTwoColumnsCell = false,
    ...restProps
  } = props;

  const classes = useStyles();

  return (
    <div
      {...restProps}
      className={clsx(className, classes.rowCell, {
        [classes.rowCellCentered]: centered,
        [classes.rowCellBold]: bold,
        [classes.fadedOut]: fadedOut,
        [classes.lastOneColumnCell]: lastOneColumnCell,
        [classes.lastTwoColumnsCell]: lastTwoColumnsCell
      })}
    >
      {children}
    </div>
  );
};

export default React.memo(TableCellWrapper);
